<template>
    <div class="default-page">
        <NavBar />
        <main class="bg-white">
            <Saudacao />
            <div class="my-3 p-3 bg-body rounded shadown-sm">                
                <RouterView></RouterView>
            </div>
        </main>
    </div>
</template>
<script setup lang="ts">
import NavBar from '@/components/NavBar.vue';
import Saudacao from '@/components/Saudacao.vue';

</script>
<style lang="less" scoped>
.default-page {
    padding-top: 56px;
}
</style>